import { tailwindSheet, baseStyles } from '../../../_shared/styles.js';

const styles = new CSSStyleSheet();
styles.replaceSync(`
    :host {
        display: block;
    }
`);

export default [tailwindSheet, baseStyles, styles];
